/**
 * 首页相关接口
 */
import request from '@/utils/request'
import baseUrl from '@/utils/baseUrl'
/**
 * 获取科技动态列表
 * @param {Object} params - 查询参数
 * @param {String} params.type - 类型：news-新闻中心, notice-通知公告
 * @param {Number} params.pageNum - 页码
 * @param {Number} params.pageSize - 每页数量
 */
export function getTechTrendsList(params) {
  return request({
    url: '/pcs/home/tech-trends',
    method: 'get',
    params
  })
}

/**
 * 获取政策信息列表
 * @param {Object} params - 查询参数
 * @param {String} params.type - 类型：tech-科技政策, interpret-政策解读
 * @param {Number} params.pageNum - 页码
 * @param {Number} params.pageSize - 每页数量
 */
export function getPolicyInfoList(params) {
  return request({
    url: '/pcs/home/policy-info',
    method: 'get',
    params
  })
}

/**
 * 获取发布统计数据
 */
export function getPublishStatistics() {
  return request({
    url: '/pcs/home/publish-statistics',
    method: 'get'
  })
}

/**
 * 获取新闻详情
 * @param {String} id - 新闻ID
 */
export function getNewsDetail(id) {
  return request({
    url: `/pcs/home/news/${id}`,
    method: 'get'
  })
}

/**
 * 提交发布需求
 * @param {Object} data - 需求数据
 */
export function submitDemand(data) {
  return request({
    url: '/pcs/home/demand',
    method: 'post',
    data
  })
}

/**
 * 获取通知/政策列表（开放接口）
 * 对应：
 *  - 新闻中心：type=2
 *  - 通知公告：type=1
 *  - 科技政策：type=3
 *  - 政策解读：type=4
 * @param {Object} params - 查询参数
 * @param {Number} params.page - 页码（从0开始）
 * @param {Number} params.pageSize - 每页数量
 * @param {Number} params.type - 类型：1/2/3/4
 */
export function getNoticeList(params) {
  const query = {
    page: params.page || 0,
    pageSize: params.pageSize || 10,
    type: params.type || 1
  }
  if (params.startDate) query.startDate = params.startDate
  if (params.endDate) query.endDate = params.endDate
  if (params.keyword) query.keyword = params.keyword
  if (params.title) query.title = params.title
  return request({
    url: '/vportal/notice/open/list',
    method: 'get',
    params: query,
    baseURL: baseUrl.apiBaseAuth,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export default {
  getTechTrendsList,
  getPolicyInfoList,
  getPublishStatistics,
  getNewsDetail,
  submitDemand,
  getNoticeList
}
